import { debounce } from 'lodash';

export const debounceAction = (func : ()=>void) => {
  return debounce(func, 500, { leading: true, trailing: false });
};
